import { RequestStatus } from 'clickNgo/configs/service/common'

import { ISectionSettingsState } from './models/iSectionSettingsState'

export const initialState: ISectionSettingsState = {
  status: RequestStatus.NONE,
  message: '',
  settings: {},
}
